import { useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import Home from "./containers/Home"
import Header from "./layout/Header/Header"
import Footer from "./layout/Footer/Footer"
import mainLogo from "./assets/images/logoPng.png"
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
      setTimeout(()=> {
        document.querySelector('.loader-wrapper').classList.add('d-none')
      },800)
  }, [])
  useEffect(() => {
    AOS.init({
      once: true,
      offset: 550
    });
    AOS.refresh();
  }, []);
  
  return (
    <>
      <Header />
      <Home />
      <Footer />
      <Loader />
      <GoToTop />
    </>
  );
}


const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="fixed-loading-wrapper">
        <div className="loader-wrapp">
          <div className="loader-logo">
            <img src={mainLogo} alt="" />
          </div>
          <div className="loader"></div>
        </div>
      </div>
    </div>
  )
}
const GoToTop = () => {
  window.onscroll = function () {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
     let btn = document.getElementById('scrollToTop');
    if (btn) {
     if(pageOffset > 450){
       btn.classList.add('show-top') 
      }else{
        btn.classList.remove('show-top') 
     }
    }
  }
  const goToTop = () => {
    window.scrollTo({
      top:0,
      behavior: "smooth"
    })
  }
  return (
    <div onClick={goToTop} className="go-to-top" id="scrollToTop">
      <ArrowUpwardIcon />
    </div>
  )
}

export default App;
